import React, { useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useCourses } from '../../context/CourseContext';
interface CertificateProps {
  courseId: string;
}
const Certificate: React.FC<CertificateProps> = ({
  courseId
}) => {
  const {
    user
  } = useAuth();
  const {
    courses,
    generateCertificate
  } = useCourses();
  const certificateRef = useRef<HTMLDivElement>(null);
  const course = courses.find(c => c.id === courseId);
  if (!course || !user) return null;
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const handleDownload = () => {
    // In a real app, you would use html-to-image or a similar library
    // to generate a downloadable image of the certificate
    alert('Certificate download functionality would be implemented here');
    generateCertificate(courseId);
  };
  return <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-84">
      <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-85">
        Your Certificate
      </h2>
      <div ref={certificateRef} className="border-4 border-blue-200 rounded-lg p-8 mb-6 bg-white" data-id="element-86">
        <div className="text-center" data-id="element-87">
          <div className="text-blue-600 font-bold text-xl mb-1" data-id="element-88">
            GoABitFurther
          </div>
          <div className="text-gray-600 font-medium mb-6" data-id="element-89">Africa Academy</div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-90">
            Certificate of Completion
          </h1>
          <p className="text-gray-600 mb-8" data-id="element-91">This certifies that</p>
          <p className="text-xl font-semibold text-blue-700 mb-8" data-id="element-92">
            {user.name}
          </p>
          <p className="text-gray-600 mb-2" data-id="element-93">
            has successfully completed the course
          </p>
          <p className="text-xl font-semibold text-gray-800 mb-8" data-id="element-94">
            "{course.title}"
          </p>
          <p className="text-gray-600 mb-8" data-id="element-95">on {currentDate}</p>
          <div className="flex justify-center mb-4" data-id="element-96">
            <div className="w-40 border-t-2 border-gray-400" data-id="element-97"></div>
          </div>
          <p className="text-sm text-gray-500" data-id="element-98">
            Director, GoABitFurther Africa Academy
          </p>
        </div>
      </div>
      <button onClick={handleDownload} className="w-full bg-blue-600 text-white py-2 px-4 rounded-md font-medium hover:bg-blue-700 transition-colors" data-id="element-99">
        Download Certificate
      </button>
    </div>;
};
export default Certificate;